import { Component, Input } from '@angular/core';
import { Suggestion } from '../../core/dto/suggestions.interface';
import { LanguageService } from '../../core/services/language.service';

@Component({
  selector: 'app-suggestion',
  templateUrl: './suggestion.component.html',
  styleUrls: ['./suggestion.component.scss']
})
export class SuggestionComponent {
  @Input() suggestion!: Suggestion
  readonly fallbackImage = 'assets/imgs/blog-cards/blog_new/default.webp';

  constructor(private langService: LanguageService) {}

  get routerLinkValue(): any {
    const link = this.suggestion?.link as any;
    if (Array.isArray(link)) return link;
    const asString = (link || '').toString();
    if (!asString) return ['/home', this.langService.lang];
    const clean = asString.startsWith('/') ? asString.substring(1) : asString;
    return this.langService.build(clean, this.langService.lang);
  }

  get backgroundImageStyle(): string {
    const img = this.suggestion?.img;
    const finalImg = img && img.trim() ? img : this.fallbackImage;
    return `url(${finalImg})`;
  }
}
